define( 'mask',[ 'jquery', 'lib/utils' ],
	function ( $, utils ) {

		'use strict';

		var Mask = function () {

				this.$el = $( '<div class="mask"></div>' );
				this.open = false;
				$( 'body' ).append( this.$el );
			},
			_singleton;

		Mask.prototype.toggle = function () {

			if ( this.open ) {
				this.hide();
			} else {
				this.show();
			}
		};

		Mask.prototype.show = function () {

			this.$el.addClass( 'mask-show' );
			this.open = true;

		};

		Mask.prototype.hide = function () {

			this.$el.removeClass( 'mask-show' );
			this.open = false;
		};

		_singleton = new Mask();

		return _singleton;
	} );

